import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import * as Icons from "@mui/icons-material";

class Navs extends Component {
  render() {
    return (
      <div className="">
        <nav
          className="navbar navbar-expand-lg  border-2 border-warning fixed-top p-1"
          style={{ backgroundColor: "#fff" }}
        >
          <div className="container" style={{ height: "80px" }}>
            <a
              className="navbar-brand p-0 "
              href="/"
              style={{ outline: "none" }}
            >
              <img
                src="/logo.png"
                alt="WealthSystem"
                style={{ height: "80px" }}
              />
            </a>

            <div
              className="navbar-collapse collapse justify-content-center d-none d-none-md d-block-lg"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav  mb-2 mb-lg-0 text-center">
                <li
                  className="nav-item"
                  style={{ paddingLeft: "30px", paddingTop: "30px" }}
                ></li>
                <li className="nav-item">
                  <NavLink
                    to="/"
                    className="nav-link px-3 "
                    aria-current="page"
                  >
                    Home
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    to="/about"
                    className="nav-link px-3 "
                    aria-current="page"
                  >
                    The System
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/cultivations"
                    className="nav-link px-3 "
                    aria-current="page"
                  >
                    Reward Schedule
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/FAQ"
                    className="nav-link px-3 "
                    aria-current="page"
                  >
                    FAQs
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/team"
                    className="nav-link px-3 "
                    aria-current="page"
                  >
                    Team
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/contact"
                    className="nav-link px-3 "
                    aria-current="page"
                  >
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div>
            <NavLink
              to="https://user.wealthsystem.net"
              aria-current="page"
              className="btn btn-secondary px-4 pe-4 py-3  d-flex  d-md-none d-none  d-lg-block"
              style={{ minWidth: "200px", fontWeight: "500" }}
            >
              Dashboard <Icons.Input style={{ marginLeft: "5px" }} />
            </NavLink>
            <NavLink
              to="https://user.wealthsystem.net/register"
              aria-current="page"
              className="btn btn-primary  px-4 pe-4 py-3  mx-3 d-flex  d-md-none d-none  d-lg-block"
              style={{ minWidth: "200px", fontWeight: "500" }}
            >
              Start Cultivation <Icons.Login style={{ marginLeft: "5px" }} />
            </NavLink>

            <span
              className="navbar-toggler   d-block d-lg-none text-center"
              onClick={this.props.toggleSideMenu}
            >
              <span>
                <Icons.Menu />
                <div className="w3-small text-center">Menu</div>
              </span>
            </span>
          </div>
        </nav>
      </div>
    );
  }
}

Navs.propTypes = {
  toggleSideMenu: PropTypes.func.isRequired, // Make sure it's a function and required
};

export default Navs;
